import React, { useEffect, useState } from "react";
import DataTable from "../../components/dataTable";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { getUserCredential, getTenantCookieData } from "../../lib/cookies";
import { GET_EMAIL_LOG_DROPDOWN_DATA, GET_EMAIL_LOG_DATA } from "../../api-setup/api-endpoints";
import {
  camelize,
  formatDate,
  formatDateOnly,
  formatDateOnlyMoment,
  getfilterDataString,
  replaceBlankAndMerge,
  toCamelCase,
  applyDateFormat,
} from "../../utils/utils";
import { columnMenuProps } from "../../components/customColumnMenu";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { HeaderPage } from "../base/headerPage";
import { Label, Error } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { LoadingPanel } from "../../components/loadingPanel";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { processTreeData } from "../../utils/treeDropdowndata";
import MessageSchema from "../../utils/messageSchema";
import { ToggleButton } from "@progress/kendo-react-dateinputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import useAPI from "./service";
import CustomDropdown from "src/components/customDropdown";
import { transformDateTime } from "src/lib/date-time.util";
import useColumnReorder from "src/custom-hooks/useColumnReorder";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { filterBy, orderBy } from "@progress/kendo-data-query";

const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const textField = "text";
const subItemsField = "items";

const fields = {
  selectField,
  expandField,
  dataItemKey,
  subItemsField,
};

const email_status = [
  { text: "Select All", id: null },
  { text: "Success", id: "success" },
  { text: "Failed", id: "failed" },
];
export const CustomToggleButton = (props) => {
  return (
    <Tooltip
      position="bottom"
      anchorElement="target"
      style={{
        paddingTop: 10,
      }}
    >
      <ToggleButton {...props} title="Calendar">
        <span className="k-icon k-font-icon k-i-calendar" title="Calendar" />
      </ToggleButton>
    </Tooltip>
  );
};

const Emaillog = (pageProps) => {
  const DEFAULT_SORT = { number: 1, order: "DESC" };
  const divRef = React.createRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultPageSize = getTenantCookieData("record_per_page");

  const cookiesData = getUserCredential();

  const [columnsData, setColumnsData] = React.useState([]);
  const [isCheckColumn, setColumnCheck] = React.useState(false);
  const [exportDataClick, setExportDataClick] = React.useState(false);
  const [exportData, setExportData] = React.useState([]);

  const [filterData, setFilterData] = React.useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    sort_order: DEFAULT_SORT.order,
  });
  const [pageData, setPage] = React.useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });
  const [filter, setFilter] = React.useState({
    value: "",
    operator: "contains",
  });

  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [dbObjTypeFields, setDataObjFields] = React.useState({
    dbObjTypeValue: {
      id: "",
      text: "",
    },
    dbObjTypeData: [],
    isDBObjDataLoading: true,
    dbTypeListLoading: true,
    screenName: "",
    type: "",
  });
  const [emailStatusFields, setEmailStatusFields] = React.useState({
    emailStatusValue: {
      id: null,
      text: "Select All",
    },
    emailStatusData: [],
    isEmailStatusDataLoading: false,
    emailStatusListLoading: true,
    screenName: "",
  });
  const [errorObj, setErrorObj] = React.useState({
    start_date: "",
    end_date: "",
    db_obj_type: "",
    commonDateValidate: "",
  });
  const [selectedEmailObject, setSelectedEmailObject] = React.useState("");
  const [gridColumns, setGridColumns] = React.useState([]);

  const [dateFields, setDateFields] = React.useState(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    return {
      start_date: new Date(year, month, 1), // Date object
      end_date: new Date(year, month + 1, 0), // Date object
    };
  });

  const [expanded, setExpanded] = React.useState([]);
  const [dropDownAppendTo, setDropdownAppendTo] = React.useState(null);
  const DATA_TABLE_ID = "email-log-grid";

  const [list, Action] = useAPI();
  const [emailDropwLoadingState, setEmailDropdownDataLoadingState] = React.useState(false);
  const [emailLogLoadingState, setEmailLogDataLoadingState] = React.useState(false);
  const [searchStateFields, setSearchStateFields] = React.useState({});
  const [positionList, setPositionsList] = React.useState({
    isOpen: false,
    data: [],
    originalData: [],
  });

  const {
    columns,
    setColumns,
    data,
    setData,
    dataCount,
    initialLoading,
    noDataFound,
    isAPICalling,
    setAPICallingState,
    isSearchClick,
    setSearchClick,
    moduleTypeFields,
    originModuleType,
    setModuleTypeFields,
    originCompPlan,
    compPlanFields,
    setcompPlanFields,
    originPeriod,
    setOriginPeriod,
    periodMasterData,
    setPeriodMasterData,
    jobdataList,
    setJobDataList,
    originJobData,
    setPositionAPICallingState,
    positionAPICallingState,
  } = list;
  const apiCallData = {
    in_filter: `AND a.etl_table_name IN ('user', 'job_master')`,
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
    in_page_row_offset: 0,
    in_page_rows: defaultPageSize.recordTake,
  };
  const jobprocessApiCallData = {
    in_tenant_id: cookiesData.out_tenant_id,
    in_select_type: "",
    in_filter: null,
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
    in_page_row_offset: 0,
    in_page_rows: defaultPageSize.recordTake,
  };

  React.useEffect(() => {
    Action.getEtlTableData(apiCallData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (moduleTypeFields.isModuleDataLoading) return;

    setDropdownAppendTo(divRef.current);
    getEmailLogDropdownData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleTypeFields.moduleValue.id]);

  function extractAndConvert(input) {
    if (!input) return "";

    // Remove "Job Execution" prefix
    let afterPrefix = input.replace(/^Job Execution\s*/i, "");

    // Convert to lowercase and replace spaces with underscores
    return afterPrefix.trim().toLowerCase().replace(/\s+/g, "_");
  }

  const getEmailLogDropdownData = async () => {
    setEmailDropdownDataLoadingState(true);
    let apiData = getAPIData();
    apiData.in_filter = null;
    apiData.in_sort_number = DEFAULT_SORT.number;
    apiData.in_sort_order = "DESC";
    apiData.in_page_row_offset = 0;
    apiData.in_page_rows = defaultPageSize.recordTake;

    let res = await Action.getEmailLogDropDownDataAsync(GET_EMAIL_LOG_DROPDOWN_DATA, apiData, dispatch);
    if (res && res?.length > 0) {
      let tempArray = [];
      let tempExpandedIds = [];

      res?.forEach((cItem) => {
        const label = cItem.email_batch_name;
        const [prefix] = label.split("_").map((s) => s.trim());

        const isJobExecution = prefix === "Job Execution";
        const shouldInclude = moduleTypeFields.moduleValue.text === "Job Master" ? isJobExecution : !isJobExecution;

        if (shouldInclude) {
          tempArray.push({
            text: cItem.email_batch_label, // Use label from different field
            id: cItem.email_batch_mstr_key,
            type: extractAndConvert(cItem.email_batch_label),
          });
        }
      });

      setDataObjFields({
        ...dbObjTypeFields,
        dbObjTypeValue: tempArray.sort((a, b) => a.text.localeCompare(b.text))[0],
        dbObjTypeData: tempArray,
        isDBObjDataLoading: false,
        dbTypeListLoading: false,
      });
      if (moduleTypeFields.moduleValue.text === "Job Master" && tempArray.length > 0) {
        let jobCode = extractAndConvert(tempArray[0].text);
        const updatedJobprocessApiCallData = {
          ...jobprocessApiCallData, // keep all old fields
          in_filter: `AND a.job_type_code = '${jobCode}'`,
        };

        await Action.getJobDataList(updatedJobprocessApiCallData, jobCode);
      }
    } else {
      setDataObjFields({
        ...dbObjTypeFields,
        isDBObjDataLoading: false,
        dbTypeListLoading: false,
      });
    }
  };

  React.useEffect(() => {
    if (columns.length === 0 && isSearchClick) {
      let apiData = getAPIData();
      apiData.in_filter = null;
      apiData.in_sort_number = DEFAULT_SORT.number;
      apiData.in_sort_order = "DESC";
      apiData.in_page_row_offset = 0;
      apiData.in_page_rows = defaultPageSize.recordTake;
      getEmailLogsAsync(apiData, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, isSearchClick]);

  React.useEffect(() => {
    if (columns.length > 0) {
      setColumnsData(columns);
      setGridColumns(columns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns]);

  React.useEffect(() => {
    if (isCheckColumn) {
      setGridColumns(columnsData);
      setColumnCheck(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckColumn]);

  const getPageTake = () => {
    return pageData.take;
  };

  const getPageSkip = () => {
    return pageData.skip;
  };

  const getAPIData = () => {
    let apiData = {};
    apiData.in_tenant_id = cookiesData.out_tenant_id;
    apiData.in_filter = null;
    apiData.in_sort_number = 2;
    apiData.in_sort_order = "DESC";
    apiData.in_page_row_offset = 0;
    apiData.in_page_rows = defaultPageSize.recordTake;
    return apiData;
  };

  const getEmailLogsAsync = async (reqBodyData, isSort) => {
    let obj = {};
    obj.reqBody = reqBodyData;
    obj.api = GET_EMAIL_LOG_DATA;

    let { api, reqBody } = obj;
    getDataListAPICall(reqBody, api);
  };

  const getStateEmailLog = async (reqBodyData, isSort) => {
    let obj = {};
    obj.reqBody = {
      ...searchStateFields,
      ...reqBodyData,
    };
    obj.api = GET_EMAIL_LOG_DATA;

    let { api, reqBody } = obj;
    getPreseveDataList(reqBody, api);
  };

  const getPreseveDataList = async (reqBody, api) => {
    let res = await Action.getListDataAsync(GET_EMAIL_LOG_DATA, reqBody, dispatch);
    if (res) {
      setAPICallingState(false);
      setSearchClick(false);
    }
  };

  const getDataListAPICall = async (reqBody, api) => {
    setAPICallingState(true);
    reqBody.in_email_batch_label = `'${dbObjTypeFields?.dbObjTypeValue?.text}'`;
    reqBody.in_user_key = 1;
    reqBody.in_email_status =
      emailStatusFields?.emailStatusValue?.id === null ? null : emailStatusFields?.emailStatusValue?.id;
    let startDate = formatDateOnlyMoment(dateFields.start_date, "YYYY-MM-DD");
    let endDate = formatDateOnlyMoment(dateFields.end_date, "YYYY-MM-DD");

    if (
      dateFields.start_date !== "" &&
      dateFields.end_date !== "" &&
      startDate !== "" &&
      endDate !== "" &&
      moduleTypeFields.moduleValue.text !== "Job Master"
    ) {
      const baseDateFilter = ` AND (DATE(a.action_date) BETWEEN "${startDate}" AND "${endDate}")`;
      reqBody.in_common_filter = baseDateFilter;
      reqBody.in_job_filter = "";
      if (reqBody.in_filter !== null) {
        reqBody.in_filter = `${reqBody.in_filter}`;
      }
    } else if (moduleTypeFields.moduleValue.text === "Job Master") {
      let jobMasterFilters = ` AND (DATE(a.action_date) BETWEEN "${startDate}" AND "${endDate}")`;
      let complankey = compPlanFields.compPlanValue.id;
      let jobkey = jobdataList.jobValue.id;
      let periodkey = periodMasterData.periodValue.id;
      let in_job_filter = "";

      if (complankey !== "" && complankey !== null) {
        in_job_filter += ` AND a.comp_plan_mstr_key = "${complankey}"`;
      }

      if (jobkey !== "" && jobkey !== null) {
        in_job_filter += ` AND a.job_mstr_key = "${jobkey}"`;
      }

      if (periodkey !== "" && periodkey !== null) {
        in_job_filter += ` AND a.period_mstr_key = "${periodkey}"`;
      }
      let type = extractAndConvert(dbObjTypeFields.dbObjTypeValue.text);
      reqBody.in_job_mstr_key = jobdataList.jobValue.id;
      reqBody.in_comp_plan_mstr_key = compPlanFields.compPlanValue.id;
      reqBody.in_period_mstr_key = periodMasterData.periodValue.id;
      reqBody.in_job_type_code = type.toLowerCase();
      reqBody.in_etl_table_name = moduleTypeFields.moduleValue?.code;
      reqBody.in_common_filter = jobMasterFilters;
      reqBody.in_job_filter = in_job_filter;

      if (reqBody.in_filter !== null) {
        reqBody.in_filter = `${reqBody.in_filter}`;
      }
    }
    setSearchStateFields(reqBody);
    let res = await Action.getListDataAsync(GET_EMAIL_LOG_DATA, reqBody, dispatch);
    if (res) {
      setAPICallingState(false);
      setSearchClick(false);
    }
  };

  const useCol = (columns) => {
    return columns.map((column, idx) => {
      return column.show && column.title !== "" && column.field !== "linked_positions_names" ? (
        <Column
          {...columnMenuProps(column)}
          key={idx}
          cell={column.field == "linked_positions" ? (props) => (
            <PositionNameCell
              {...props}
              compPlanFields={compPlanFields}
            />
          ) : StringReandOnlyCell}
          sortable={column.field === "linked_positions" ? false : true}
          width={column.minWidth}
          // sortable={column.field === 'linked_positions' ? false : true}
          format={column.format}
          resizable={true}
        />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  // const customLinkCell = React.useCallback((props) => {
  //   console.log("props", props.field);
  //   const { ariaColumnIndex, columnIndex, dataItem, field } = props;

  //   let val = dataItem[field || ""];

  //   if (field.indexOf("_mstr_key") !== -1) {
  //     val = dataItem[field.replace("_mstr_key", "_name") || ""];
  //   }
  //   let value = props.field;

  //   const defaultRendering = (
  //     <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
  //       <span title={val}>
  //         <a
  //           className="tablelink"
  //           onClick={() => {
  //             let selectedItem = val; // default

  //             history.push("/pipeline", { selectedItem });
  //           }}
  //         >
  //           {val}
  //         </a>
  //       </span>
  //     </td>
  //   );

  //   return defaultRendering;
  // }, []);

  const onClosePopup = () => {
    setPositionsList({
      ...positionList,
      isOpen: false,
      data: [],
      originalData: [],
    });
  };

  const PositionNameCell = React.useCallback((props) => {
    const { dataItem, compPlanFields } = props;

    const onLinkClick = async () => {
      if (dataItem?.db_role_type_abbr?.toLowerCase() === "prv1") return;
      if (dataItem?.linked_positions?.toString() === "0" || dataItem?.linked_positions === null) return;
      setPositionAPICallingState(true);
      let apiCallData = {
        in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
        in_period_mstr_key: dataItem.period_mstr_key,
        in_job_type_mstr_key: dataItem.job_type_mstr_key,
        in_job_mstr_keys: dataItem.job_mstr_key,
        in_org_title_keys: "0",
        in_filter: `AND ( a.proc_ctrl_mstr_key = '${dataItem.proc_ctrl_mstr_key}' )  AND ( a.is_processed = 1 )  `,
        in_comp_plan_mstr_key: compPlanFields?.compPlanValue?.id || "",
        in_bgm_user_key: dataItem.db_role_type_abbr === "bgm1" ? dataItem.user_key : null,
        in_group_by: null,
        in_sort_number: 11,
        in_sort_order: "DESC",
        in_page_row_offset: 0,
        in_page_rows: 9999,
      };
      let res = await Action.getLinkedPositionsDataAsync(apiCallData, "");
      if (res) {
        setPositionAPICallingState(false);
        setPositionsList({
          isOpen: true,
          data: res,
          originalData: res,
        });
      }
    };

    return (
      <td
        style={{
          textAlign: "center",
        }}
      >
        <span
          className={
            dataItem?.db_role_type_abbr?.toLowerCase() === "prv1"
              ? ""
              : dataItem?.linked_positions?.toString() === "0" || dataItem?.linked_positions === null
                ? ""
                : "link-class"
          }
          onClick={() => {
            onLinkClick();
          }}
        >
          {dataItem.linked_positions || 0}
        </span>
      </td>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PositionStringReadOnlyCell = React.useCallback((props) => {
    const { ariaColumnIndex, columnIndex, dataItem, field } = props;

    let val = dataItem[field || ""];

    const defaultRendering = (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
        <span title={val}>{val}</span>
      </td>
    );

    return defaultRendering;
  }, []);

  const StringReandOnlyCell = React.useCallback((props) => {
    const { ariaColumnIndex, columnIndex, dataItem, field } = props;

    let val = dataItem[field || ""];

    if (field.indexOf("_mstr_key") !== -1) {
      val = dataItem[field.replace("_mstr_key", "_name") || ""];
    }
    let value = props.field;

    const defaultRendering = (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
        <span title={value === "email_sent_status" && val ? val[0]?.toUpperCase() + val.slice(1) : val}>
          {value === "email_sent_status" && val ? val[0]?.toUpperCase() + val.slice(1) : val}
        </span>
      </td>
    );

    return defaultRendering;
  }, []);

  let AuditColumn = useCol(gridColumns);

  const onClearFilter = () => {
    let apiData = getAPIData();
    const dataVal = {
      ...apiData,
      in_filter: null,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };

    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
    });

    getEmailLogsAsync(dataVal, filterData.isSort);
  };

  const onClearPositionFilter = () => {
    setPositionsList({
      ...positionList,
      data: positionList.originalData,
    });
  };

  const handlePositionColumnMenu = (filterAndSortData, isSort) => {
    if (isSort) {
      let filteredData = orderBy(positionList.data, filterAndSortData);
      setPositionsList({
        ...positionList,
        data: filteredData,
      });
    } else {
      let filteredData = filterBy(positionList.data, filterAndSortData.filter);
      setPositionsList({
        ...positionList,
        data: filteredData,
      });
    }
  };

  const handleColumnMenu = async (columnMenuData, isFilter, isSort) => {
    let index = 1;
    let filterSkip = getPageSkip();
    let filterTake = getPageTake();

    if (isFilter) {
      filterSkip = 0;
      filterTake = pageSize.recordTake;

      //reset pager when filter applies
      setPage({ skip: filterSkip, take: filterTake });
    }

    if (data.length > 0 && columnMenuData[0] !== undefined) {
      let obj = Object.keys(data[0]);
      index = obj.findIndex((x) => x === columnMenuData[0].field) + 1;
    }

    let filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;
    isFilter = false;
    filterString = replaceBlankAndMerge(filterString);

    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }

    const dataVal = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: isFilter ? filterString : null,
      in_sort_number: sortNumber,
      in_sort_order: sortDir,
      in_page_row_offset: filterSkip,
      in_page_rows: filterTake,
      in_user_key: cookiesData.out_user_id.toString(),
      in_user_role_filter: "> 0",
    };
    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });

    setAPICallingState(true);

    if (isFilter) {
      getEmailLogsAsync(dataVal, isSort);
    } else {
      getStateEmailLog(dataVal, isSort);
    }
  };

  const itemChange = (event) => {
    const field = event.field || "";
    const newData = data.map((item) =>
      item.user_key === event.dataItem.user_key ? { ...item, [field]: event.value } : item
    );
    setData(newData);
  };

  const getInFilter = () => {
    return filterData.isFilter ? filterData.data : null;
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const handlePageChange = async (event) => {
    const pageData = event.page;
    setAPICallingState(true);
    setPage({ skip: pageData.skip, take: pageData.take });
    let apiCallData = getAPIData();
    apiCallData.in_filter = getInFilter();
    apiCallData.in_sort_number = getInSortNumber();
    apiCallData.in_sort_order = getInSortOrder();
    apiCallData.in_page_rows = pageData.take;
    apiCallData.in_page_row_offset = pageData.skip;
    getStateEmailLog(apiCallData, filterData.isSort);
  };

  const onRefreshClick = async () => {
    setAPICallingState(true);
    let apiData = getAPIData();
    const dataVal = {
      ...apiData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };

    await getStateEmailLog(dataVal, filterData.isSort);
  };

  const handleMenuItemClick = (action) => {
    switch (action) {
      case "export":
        setExportData([]);
        setExportDataClick(true);
        break;
      default:
        break;
    }
  };

  const headerConfig = {
    title: "Email Logs",
    id: "email_log",
    action_menu: {
      export: { fx: handleMenuItemClick },
    },
    manage_col: {
      columnsData: columnsData,
      setColumnsData: setColumnsData,
      setColumnCheck: setColumnCheck,
    },
  };

  const onSearchButtonClick = () => {
    let isValid = handleValidation();
    if (isValid) {
      setPageSize(defaultPageSize);
      setPage({
        skip: 0,
        take: defaultPageSize.recordTake,
      });
      let selectedEmailObjectValue = dbObjTypeFields.dbObjTypeValue.text;
      setSelectedEmailObject(selectedEmailObjectValue);
      setData([]);
      setColumns([]);
      setSearchClick(true);
      setFilterData({
        isSort: false,
        isFilter: false,
        data: "",
        in_sort_number: DEFAULT_SORT.number,
        sort_order: DEFAULT_SORT.order,
      });
    }
  };

  const parent = document.querySelector("#content-" + headerConfig.id);

  if (parent) {
    const exportToExcel = parent.querySelector(".export-to-excel");
    exportToExcel && exportToExcel.disableKendoMenu();
    data.length && exportToExcel && exportToExcel.enableKendoMenu();
  }

  const getExportData = async () => {
    setExportData([]);
    let apiData = getAPIData();
    const dataVal = {
      ...apiData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };
    // let startDate = formatDateOnly(dateFields.start_date);
    // let endDate = formatDateOnly(dateFields.end_date);

    let response = "";
    let obj = {};
    obj.reqBody = searchStateFields;

    obj.api = GET_EMAIL_LOG_DATA;
    obj.reqBody.in_filter = getInFilter();
    obj.reqBody.in_sort_number = getInSortNumber();
    obj.reqBody.in_sort_order = getInSortOrder();
    obj.reqBody.in_export_flag = 1;
    obj.reqBody.in_page_rows = dataCount;
    // obj.reqBody.in_email_batch_label = `'${dbObjTypeFields?.dbObjTypeValue?.text}'`;
    // obj.reqBody.in_user_key = 1;
    // obj.reqBody.in_email_status = emailStatusFields?.emailStatusValue?.id;

    response = await Action.getExportDataAsync(GET_EMAIL_LOG_DATA, obj.reqBody, dispatch);

    await getStateEmailLog(dataVal, filterData.isSort);

    if (response && response.length > 0) {
      setExportData(response);
    }
  };

  const handleValidation = () => {
    let isValid = true;
    let errObj = {};
    const { start_date, end_date } = dateFields;
    if (start_date && end_date) {
      const startDateObj = new Date(start_date);
      const endDateObj = new Date(end_date);

      if (start_date && end_date) {
        if (startDateObj > endDateObj) {
          errObj.commonDateValidate = MessageSchema.validDate;
        } else {
          errObj.commonDateValidate = "";
        }
      }
    } else {
      if (start_date === "" || start_date === null) {
        errObj.start_date = MessageSchema.actionStartDateRequired;
      }
      if (end_date === "" || end_date === null) {
        errObj.end_date = MessageSchema.actionEndDateRequired;
      }
    }

    if (dbObjTypeFields.dbObjTypeValue === "" || dbObjTypeFields.dbObjTypeValue === null) {
      errObj.db_obj_type = MessageSchema.screenNameRequired;
    } else {
      errObj.db_obj_type = "";
    }

    setErrorObj({ ...errObj });

    for (const [, value] of Object.entries(errObj)) {
      if (value !== "") {
        isValid = false;
      }
    }
    return isValid;
  };

  const onChangeEmailStatus = (e) => {
    setEmailStatusFields({
      ...emailStatusFields,
      emailStatusValue: e,
      screenName: e.text.replace(/\s/g, "").toLowerCase(),
    });
  };
  const onChange = async (e) => {
    setDataObjFields({
      ...dbObjTypeFields,
      dbObjTypeValue: e,
      screenName: e.text.replace(/\s/g, "").toLowerCase(),
      type: extractAndConvert(e.text),
    });
    let type = extractAndConvert(e.text);
    const updatedJobprocessApiCallData = {
      ...jobprocessApiCallData, // keep all old fields
      in_filter: `AND a.job_type_code = '${type}'`,
    };

    await Action.getJobDataList(updatedJobprocessApiCallData, type);
  };

  const { dbObjTypeValue: value } = dbObjTypeFields;
  const treeData = React.useMemo(
    () => {
      return processTreeData(
        dbObjTypeFields.dbObjTypeData,
        {
          expanded,
          value,
          filter,
        },
        fields
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [expanded, dbObjTypeFields, filter]
  );

  const onFilterChange = (event) => setFilter(event.filter);

  const handleDateChange = (e) => {
    setDateFields({
      ...dateFields,
      [e.target.name]: e.target.value,
    });
    setErrorObj({
      ...errorObj,
      [e.target.name]: "",
      commonDateValidate: "",
    });
  };

  const exportFileName = () => {
    let name = camelize(selectedEmailObject.toLowerCase());
    let fileName = "";
    fileName = `Export_Email_Log_${name}.xlsx`;
    return fileName;
  };

  const checkSearchButton = () => {
    const isStartDateEmpty = dateFields.start_date === "";
    const isEndDateEmpty = dateFields.end_date === "";
    const isDbTypeValueEmpty =
      !dbObjTypeFields.dbObjTypeValue ||
      Array.isArray(dbObjTypeFields.dbObjTypeValue) ||
      dbObjTypeFields.dbObjTypeValue.text === "";

    // For job_master module, check additional fields
    if (moduleTypeFields.moduleValue.text === "job_master") {
      const isJobEmpty = jobdataList.jobValue.text === "";
      const isCompPlanEmpty = compPlanFields.compPlanValue.text === "";

      return (
        dbObjTypeFields.dbTypeListLoading ||
        isStartDateEmpty ||
        isEndDateEmpty ||
        isDbTypeValueEmpty ||
        isJobEmpty ||
        isCompPlanEmpty
      );
    }

    // For other modules (like user)
    return dbObjTypeFields.dbTypeListLoading || isStartDateEmpty || isEndDateEmpty || isDbTypeValueEmpty;
  };

  const { columnReorderData } = useColumnReorder(cookiesData, setColumnsData, "", "procare_system");

  const positionsColumn = [
    {
      title: "Position Name",
      show: true,
      field: "position_name",
      minWidth: 150,
      filterable: true,
      type: "string",
    },
  ];

  const positionUseCol = (columns) => {
    return columns.map((column, idx) => {
      return column.show && column.title !== "" ? (
        <Column {...columnMenuProps(column)} key={idx} sortable={true} width={150} cell={PositionStringReadOnlyCell} />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  let PositionColumn = positionUseCol(positionsColumn);

  return (
    <>
      <div className="Main">
        <div className="content">
          <div className="content-head">
            <HeaderPage pageProps={pageProps} headerConfig={headerConfig} />
          </div>

          <div className="content-body">
            <div className="dtu-file-container">
              <ul className={"Filter-links auditlogform"}>
                <div ref={divRef} className={"k-form-field-wrap-popup width20em"}>
                  <Label>{"Data Elements:"}</Label>
                  <CustomDropdown
                    name="moduleValue"
                    data={moduleTypeFields.moduleData}
                    textField="text"
                    dataItemKey="id"
                    valueData={originModuleType.find((c) => c.text === moduleTypeFields.moduleValue?.text)}
                    onOpen={() => {
                      setModuleTypeFields((prev) => ({
                        ...prev,
                        moduleData: originModuleType,
                      }));
                    }}
                    onChange={async (e, name) => {
                      const selectedModule = e?.text || "";

                      setDataObjFields({
                        dbObjTypeValue: {
                          id: "",
                          text: "",
                        },
                        dbObjTypeData: [],
                        isDBObjDataLoading: true,
                        dbTypeListLoading: true,
                        screenName: "",
                        type: "",
                      });

                      setModuleTypeFields((prev) => ({
                        ...prev,
                        [name]: e,
                      }));
                      // Reset other fields when module is not job_master
                      if (selectedModule !== "Job Master") {
                        setcompPlanFields({
                          ...compPlanFields,
                          compPlanValue: { text: "", id: "" },
                          compPlanData: [],
                        });

                        setPeriodMasterData({
                          ...periodMasterData,
                          periodValue: { text: "", id: "" },
                          periodData: [],
                        });

                        setJobDataList({
                          ...jobdataList,
                          jobValue: { text: "", id: "" },
                        });
                      }
                    }}
                    filterable={false}
                    autoClose={false}
                    autoBind={true}
                    dataList={originModuleType}
                    loading={moduleTypeFields.isModuleTypeDataLoading}
                  />
                </div>

                <div ref={divRef} className={"k-form-field-wrap-popup joblable"}>
                  <Label>{moduleTypeFields.moduleValue?.text !== "Job Master" ? "Email Object:" : "Job Type"}</Label>
                  <CustomDropdown
                    dropDownAppendTo={dropDownAppendTo}
                    data={treeData.sort((a, b) => a.text.localeCompare(b.text))}
                    textField="text"
                    dataItemKey="id"
                    valueData={treeData.find((c) => c.text === dbObjTypeFields.dbObjTypeValue.text)}
                    value={dbObjTypeFields.dbObjTypeValue?.text || ""}
                    onChange={onChange}
                    autoClose={false}
                    autoBind={true}
                    loading={dbObjTypeFields.isDBObjDataLoading}
                    filterable={false}
                  />
                  <Error>{errorObj.db_obj_type}</Error>
                </div>

                {moduleTypeFields.moduleValue.text === "Job Master" && (
                  <>
                    <div ref={divRef} className={"k-form-field-wrap-popup joblable"}>
                      <Label>{"Job Name:"}</Label>
                      <CustomDropdown
                        name={"jobValue"}
                        data={
                          dbObjTypeFields.dbObjTypeData.length > 0
                            ? jobdataList?.jobData.filter((x) => x.text !== null) || []
                            : []
                        }
                        textField="text"
                        dataItemKey="id"
                        valueData={(() => {
                          const job = originJobData.find(
                            (c) => c.text !== null && c.text === jobdataList.jobValue.text
                          );

                          if (!job) return null;

                          return {
                            ...job,
                            text: job.text && job.text.length > 25 ? job.text.substring(0, 25) + " ..." : job.text,
                          };
                        })()}
                        onOpen={(dataValue) => {
                          setJobDataList({
                            ...jobdataList,
                            jobData: originJobData,
                          });
                        }}
                        onChange={(e, name) => {
                          setJobDataList({
                            ...jobdataList,
                            [name]: e,
                          });
                          Action.getCompPlanData(jobprocessApiCallData, e);
                        }}
                        onFilterChange={(dataValue) => {
                          setJobDataList({
                            ...jobdataList,
                            jobData: dataValue,
                          });
                        }}
                        filterable={true}
                        autoClose={false}
                        autoBind={true}
                        dataList={originJobData}
                        loading={dbObjTypeFields.dbObjTypeData.length > 0 ? jobdataList.isJobDataLoading : false}
                      />
                    </div>
                    {dbObjTypeFields?.dbObjTypeValue?.type !== "stage_hook" &&
                      dbObjTypeFields?.dbObjTypeValue?.type !== "email_process" && (
                        <div ref={divRef} className="k-form-field-wrap-popup joblable">
                          <Label>{"Comp Plan: "}</Label>
                          <CustomDropdown
                            name={"compPlanValue"}
                            data={
                              dbObjTypeFields.dbObjTypeData.length > 0
                                ? compPlanFields?.compPlanData.filter((x) => x.text !== null) || []
                                : []
                            }
                            textField="text"
                            dataItemKey="id"
                            valueData={(() => {
                              const compPlan = originCompPlan.find(
                                (c) => c.text !== null && c.text === compPlanFields.compPlanValue.text
                              );

                              if (!compPlan) return null;

                              return {
                                ...compPlan,
                                text:
                                  compPlan.text && compPlan.text.length > 25
                                    ? compPlan.text.substring(0, 25) + "..."
                                    : compPlan.text,
                              };
                            })()}
                            onOpen={(dataV) => {
                              setcompPlanFields({
                                ...compPlanFields,
                                compPlanData: dataV,
                              });
                            }}
                            onChange={(e, name) => {
                              setcompPlanFields({
                                ...compPlanFields,
                                [name]: e,
                              });

                              Action.fetchCompPlanPeriods(e.id); // API call
                            }}
                            onFilterChange={(dataValue) => {
                              setcompPlanFields({
                                ...compPlanFields,
                                compPlanData: dataValue,
                              });
                            }}
                            filterable={true}
                            autoClose={false}
                            autoBind={true}
                            dataList={originCompPlan}
                            loading={
                              dbObjTypeFields.dbObjTypeData.length > 0 ? compPlanFields.iscompPlanDataLoading : false
                            }
                          />
                        </div>
                      )}

                    <div ref={divRef} className={"k-form-field-wrap-popup jobfield"}>
                      <Label>{"Comp Plan Period:"}</Label>
                      <CustomDropdown
                        name={"periodValue"}
                        data={
                          dbObjTypeFields.dbObjTypeData.length > 0
                            ? periodMasterData?.periodData.filter((x) => x.text !== null) || []
                            : []
                        }
                        textField="text"
                        dataItemKey="id"
                        valueData={originPeriod.find((c) => c.text === periodMasterData.periodValue.text)}
                        onOpen={(dataV) => {
                          setPeriodMasterData({
                            ...periodMasterData,
                            periodData: dataV,
                          });
                        }}
                        onChange={(e, name) => {
                          setPeriodMasterData({
                            ...periodMasterData,
                            [name]: e,
                          });
                        }}
                        onFilterChange={(dataValue) => {
                          setPeriodMasterData({
                            ...periodMasterData,
                            periodData: dataValue,
                          });
                        }}
                        filterable={true}
                        autoClose={false}
                        autoBind={true}
                        dataList={originPeriod}
                        loading={
                          dbObjTypeFields.dbObjTypeData.length > 0 ? periodMasterData.isPeriodDataLoading : false
                        }
                      />
                    </div>
                  </>
                )}

                <div ref={divRef} className={"k-form-field-wrap-popup jobfield"}>
                  <Label>{"Email Status:"}</Label>
                  <CustomDropdown
                    data={email_status}
                    textField="text"
                    dataItemKey="id"
                    valueData={email_status.find((c) => c.text === emailStatusFields.emailStatusValue.text)}
                    value={emailStatusFields.emailStatusValue}
                    onChange={onChangeEmailStatus}
                    onFilterChange={onFilterChange}
                    autoClose={false}
                    autoBind={true}
                    filterable={false}
                  />
                  <Error>{errorObj.db_obj_type}</Error>
                </div>

                <div className={"k-form-field-wrap-popup valueDropdown jobfield"}>
                  <Label>{"Start Date* : "}</Label>
                  <DatePicker
                    value={dateFields?.start_date}
                    name="start_date"
                    format="yyyy-MM-dd"
                    onChange={(e) => {
                      handleDateChange(e);
                    }}
                    formatPlaceholder={{
                      year: "yyyy",
                      month: "mm",
                      day: "dd",
                    }}
                    placeholder="yyyy-mm-dd"
                    toggleButton={CustomToggleButton}
                  />
                  <Error>{errorObj.start_date}</Error>
                </div>
                <Error>{dbObjTypeFields.startDateError}</Error>
                <div className={"k-form-field-wrap-popup valueDropdown jobfield"}>
                  <Label>{"End Date* : "}</Label>
                  <DatePicker
                    toggleButton={CustomToggleButton}
                    value={dateFields?.end_date}
                    name="end_date"
                    format="yyyy-MM-dd"
                    onChange={(e) => {
                      handleDateChange(e);
                    }}
                    formatPlaceholder={{
                      year: "yyyy",
                      month: "mm",
                      day: "dd",
                    }}
                    placeholder="yyyy-mm-dd"
                  />
                  <Error>{errorObj.end_date}</Error>
                  <Error>{errorObj.commonDateValidate}</Error>
                </div>
                <Error>{dateFields.validationError}</Error>

                <Button
                  primary={true}
                  className="searchbtn"
                  disabled={
                    moduleTypeFields.moduleValue.text !== "Job Master"
                      ? dbObjTypeFields.dbObjTypeData.length == 0 || dbObjTypeFields.isDBObjDataLoading
                      : jobdataList.isJobDataLoading ||
                      compPlanFields.iscompPlanDataLoading ||
                      periodMasterData.isPeriodDataLoading
                  }
                  type={"submit"}
                  onClick={(e) => {
                    onSearchButtonClick();
                  }}
                >
                  <i className="fas fa-search"></i>
                </Button>
              </ul>

              <div className="auditLog-title">
                <h1>{selectedEmailObject}</h1>
              </div>

              {isSearchClick ? <LoadingPanel /> : false}
              {emailLogLoadingState ? <LoadingPanel /> : false}

              {gridColumns.length > 0 && !isSearchClick && (
                <>
                  <DataTable
                    isAPICalling={isAPICalling}
                    initialLoading={initialLoading}
                    data={data}
                    id={DATA_TABLE_ID}
                    itemChange={itemChange}
                    pageData={pageData}
                    dataCount={dataCount}
                    customColumn={AuditColumn}
                    columns={gridColumns}
                    module={"emailLog"}
                    fileName={exportFileName()}
                    defaultPageSize={defaultPageSize}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    handlePageChange={handlePageChange}
                    handleColumnMenu={handleColumnMenu}
                    refreshClick={onRefreshClick}
                    onClearFilter={onClearFilter}
                    noDataFound={noDataFound}
                    isExportDataClick={exportDataClick}
                    setExportData={setExportDataClick}
                    getExportData={getExportData}
                    exportData={exportData}
                    reorderable={true}
                    isDragMode={false}
                    columnReorderData={columnReorderData}
                  />
                </>
              )}
              {positionAPICallingState && <LoadingPanel />}
              {positionList.isOpen && (
                <Window title={"Assigned Positions"} onClose={onClosePopup} width={450} height={480}>
                  <div className="dtu-file-container-logs">
                    <DataTable
                      isAPICalling={false}
                      initialLoading={true}
                      data={positionList.data}
                      dataCount={positionList.data.length}
                      customColumn={PositionColumn}
                      columns={positionsColumn}
                      isPagination={false}
                      className={"DataTable-dtuLog"}
                      module={"email-log-position-grid"}
                      reorderable={false}
                      handleColumnMenu={handlePositionColumnMenu}
                      onClearFilter={onClearPositionFilter}
                      gridHeight={"340px"}
                    />
                  </div>
                  <WindowActionsBar layout={"end"}>
                    <Button className="cancelbtn" onClick={(e) => onClosePopup()} autoFocus={true}>
                      {"Cancel"}
                    </Button>
                  </WindowActionsBar>
                </Window>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(Emaillog);
